import { ShortIdHelper } from './short-id.helper';

/**
 * UUID pattern: 8-4-4-4-12 hex with hyphens (case-insensitive).
 */
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Migrates localStorage entries with `ha.` prefix from UUID-based uid values to SIDs.
 * Handles JSON arrays of objects and plain JSON objects with a `uid` field.
 * Non-JSON values and keys without `ha.` prefix are left untouched.
 */
export function migrateLocalStorageToSid(): void {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (!key || !key.startsWith('ha.')) {
            continue;
        }

        const raw = localStorage.getItem(key);
        if (!raw) {
            continue;
        }

        let parsed: unknown;
        try {
            parsed = JSON.parse(raw);
        } catch {
            continue;
        }

        let changed = false;

        if (Array.isArray(parsed)) {
            for (const item of parsed) {
                if (convertUidField(item)) {
                    changed = true;
                }
            }
        } else if (typeof parsed === 'object' && parsed !== null) {
            if (convertUidField(parsed as Record<string, unknown>)) {
                changed = true;
            }
        }

        if (changed) {
            localStorage.setItem(key, JSON.stringify(parsed));
        }
    }
}

/**
 * Converts the `uid` field of an object from UUID to SID if applicable.
 * @returns true if the field was converted
 */
function convertUidField(obj: Record<string, unknown>): boolean {
    if (typeof obj.uid !== 'string' || !UUID_PATTERN.test(obj.uid)) {
        return false;
    }

    obj.uid = ShortIdHelper.fromUuid(obj.uid);
    return true;
}
